import { useEffect } from 'react';
import googleTagManager from 'utilities/googleTagManager';
import queryString from 'query-string';

// set product in google tag manager
const useQueryStringProduct = () => {
  useEffect(() => {
    const { product } = queryString.parse(window.location.search);
    let customerId;
    if (localStorage) {
      customerId = localStorage.getItem('cove-customer-id');
    }

    const data = {};
    if (customerId) {
      data.userId = customerId;
    }
    if (product) {
      data.productType = product === 'vehicle' ? 'carcomprehensive' : 'pet';
    }

    if (customerId || product) {
      googleTagManager.pushDataLayer(data);
    }
  }, []);
  return null;
};

export default useQueryStringProduct;
